export const RES_DOMAIN = 'https://fileimosscdn.lejiaolexue.com/rest/dl/'

export const IMAGE_URL = {
  BG_MUDAN: RES_DOMAIN + 'de4ba6f5f0ce7f3944240507b33a44fa9734adfa.png',
  BG_BTN: RES_DOMAIN + '74031377aa830514e33e2a5c771f1c5c546c0e8c.png',
  BG_MODAL: RES_DOMAIN + 'd86632dbc7468dd556ea433f444e825b03eada87.png',
  BG_START: RES_DOMAIN + '008e96ebd574325593e873e4fd10540a922fed58.png',
}
